import styled from 'styled-components';


const UserDropdownWrapper = styled.div`
  margin: 0 auto;
`;


export default { UserDropdownWrapper };
